import { css } from '@emotion/react';

export default css({
    '.marketer-profile-picture':{
        '&__submit-button': {
            marginTop: '.5rem',
        }
    }
});
